__webpack_require__.p = "https://static.bonjoro.com/b36d40c39bd1a43cae38542b9b4b4352c5a41590/assets/bundle/";